var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isSystemOrOrgAdmin)?_c('system-admin-home-view-content-component'):(_vm.isUserOrBusinessAdmin)?_c('business-home-view-content-component'):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }